import {
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Text,
    Image,
    Box,
    Flex,
    Button
} from '@chakra-ui/react'
import Keys from './Keys'
import GroupRadios from './GroupRadios'
import useAmountField from './useAmountField'
import { DiscountProps } from './types'
import PaymentOptions from './PaymentOptions'
import { paymentLogos } from './PaymentLogos'
import useStorage from '../../hooks/useStorage'

export default function ModalKeyboard({
    element,
    maxValue,
    onlyAmount = false,
    onDone,
    title,
    subPaymentTypes,
    ...props
}: DiscountProps) {
    const {
        refInput,
        mode,
        setMode,
        isOpen,
        setOpen,
        submitHandler,
        changeHandler,
        paymentOption,
        setPaymentOption,
        closeModal,
        isUnchecked,
        setUnchecked,
        refRef,
        refLote,
        refForm
    } = useAmountField(maxValue, onDone, onlyAmount, subPaymentTypes, {
        selectedSubPaymentType: props.selectedSubPaymentType,
        defaultValue: props.defaultValue
    })
    const { business_variables } = useStorage()
    const isEnabledRefAndLoteDelivery =
        business_variables.find(bv => bv.code === '032')?.value === '1'
    function clickButtonSubmit() {
        if (!refRef.current || refRef.current?.value == '') {
            refRef.current?.focus()
        } else if (!refLote.current || refLote.current?.value == '') {
            refLote.current?.focus()
        } else {
            if (refRef.current?.value.length < 4) {
                refRef.current.value = refRef.current.value.padStart(4, '0')
            }
            if (refLote.current?.value.length < 4) {
                refLote.current.value = refLote.current.value.padStart(4, '0')
            }
            refForm.current?.requestSubmit()
        }
    }
    function handleKeyDown(e: any) {
        if (e.key === 'Enter') {
            clickButtonSubmit()
        }
    }
    function handleChangeRefLote(ev: any) {
        const regex = /^[0-9]+$/g
        let result = regex.test(ev.target.value)
            ? ev.target.value
            : ev.target.value.replace(/[^\d]/g, '')
        if (result.length > 4) {
            result = result.slice(0, 4)
        }
        ev.target.value = result
    }
    return (
        <>
            {element(() => setOpen(true))}
            <Modal isOpen={isOpen} onClose={closeModal} size="lg">
                <ModalOverlay />
                <ModalContent px={{ base: 3, md: 6 }} py={4}>
                    <form
                        onSubmit={e => submitHandler(e, props.paymentTypeId)}
                        noValidate
                        ref={refForm}
                    >
                        <ModalBody pb={6}>
                            {props.selectedSubPaymentType ? (
                                <Box
                                    display="flex"
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    h="90px"
                                    w="90px"
                                    minW="90px"
                                    margin={'0 auto'}
                                >
                                    <Image
                                        src={
                                            paymentLogos[
                                                props.selectedSubPaymentType
                                                    .path
                                            ]
                                        }
                                        alt={props.selectedSubPaymentType.name}
                                        maxW="70%"
                                        maxH="70%"
                                        h="auto"
                                        w="auto"
                                    />
                                </Box>
                            ) : (
                                <Text
                                    fontSize="2xl"
                                    fontWeight="bold"
                                    textAlign="center"
                                    mb="3"
                                >
                                    {title}
                                </Text>
                            )}

                            {!props.selectedSubPaymentType ? (
                                <PaymentOptions
                                    type={paymentOption}
                                    onClick={setPaymentOption}
                                    subTypes={subPaymentTypes}
                                    refInput={refInput}
                                    isUnchecked={isUnchecked}
                                    setUnchecked={setUnchecked}
                                />
                            ) : null}

                            <Text textAlign="center">
                                Ingresa la cantidad del monto
                            </Text>
                            <Input
                                w="full"
                                ref={refInput}
                                autoFocus
                                fontSize="24px"
                                fontWeight="bold"
                                h="50px"
                                borderRadius="xl"
                                my="4"
                                onChange={changeHandler}
                                onKeyDown={handleKeyDown}
                            />
                            {!onlyAmount && (
                                <GroupRadios
                                    mode={mode}
                                    refInput={refInput}
                                    onChange={setMode}
                                />
                            )}
                            <Keys
                                refInput={refInput}
                                mode={mode}
                                maxValue={maxValue}
                                refRef={refRef}
                                refLote={refLote}
                                refForm={refForm}
                                paymentTypeId={props.paymentTypeId}
                            />
                            {isEnabledRefAndLoteDelivery &&
                            props.paymentTypeId == 2 ? (
                                <>
                                    <Flex align="center" mt="4" w="100%">
                                        <Box flex="1" h="1px" bg="gray.300" />
                                        <Text
                                            fontSize="xs"
                                            fontWeight="semibold"
                                            color="gray.800"
                                            letterSpacing="wider"
                                            px="3"
                                            whiteSpace="nowrap"
                                        >
                                            DATOS DEL VOUCHER POS
                                        </Text>
                                        <Box flex="1" h="1px" bg="gray.300" />
                                    </Flex>
                                    <Flex direction="row">
                                        <Text mt="2" w="50%">
                                            REF
                                        </Text>
                                        <Text mt="2" w="50%">
                                            LOTE
                                        </Text>
                                    </Flex>
                                    <Flex direction="row">
                                        <Flex w="50%">
                                            <Input
                                                w="95%"
                                                fontSize="24px"
                                                borderRadius="xl"
                                                my="1"
                                                pr="50"
                                                ref={refRef}
                                                onKeyDown={handleKeyDown}
                                                onChange={handleChangeRefLote}
                                            />
                                        </Flex>
                                        <Flex w="50%">
                                            <Input
                                                w="95%"
                                                fontSize="24px"
                                                borderRadius="xl"
                                                my="1"
                                                pr="50"
                                                ref={refLote}
                                                onKeyDown={handleKeyDown}
                                                onChange={handleChangeRefLote}
                                            />
                                        </Flex>
                                    </Flex>
                                    <Flex
                                        direction="row"
                                        justify="center"
                                        align="center"
                                    >
                                        <Button
                                            mt="2"
                                            h="50px"
                                            colorScheme="green"
                                            rounded="lg"
                                            fontSize="18px"
                                            onClick={() => clickButtonSubmit()}
                                        >
                                            Confirmar pago con tarjeta
                                        </Button>
                                    </Flex>
                                </>
                            ) : null}
                        </ModalBody>
                    </form>
                </ModalContent>
            </Modal>
        </>
    )
}
